import React from 'react';
import { Switch } from '@headlessui/react';

const StudyModeSwitch = ({ isStudyMode, onChange }) => {
  return (
    <Switch.Group>
      <div className="flex items-center">
        <Switch.Label className="mr-2 text-sm text-neutral-600">
          Study Mode
        </Switch.Label>
        <Switch
          checked={isStudyMode}
          onChange={onChange}
          className={`${
            isStudyMode ? 'bg-cranberry-700' : 'bg-neutral-300'
          } relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-cranberry-700 focus:ring-offset-2`}
        >
          <span
            className={`${
              isStudyMode ? 'translate-x-6' : 'translate-x-1'
            } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
          />
        </Switch>
      </div>
    </Switch.Group>
  );
};

export default StudyModeSwitch; 